module.exports = __webpack_public_path__ + "img/transparent.2680e9c2.svg";